<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <label class="required">{{ $t('wholesale.date') }}</label>
      <a-date-picker
        v-model="model.stock_out_date"
        format="DD-MM-YYYY"
        valueFormat="DD-MM-YYYY"
        class="ts-w-full"
      ></a-date-picker>
      <div class="validate" v-if="errors.has('stock_out_date')">
        {{ errors.first('stock_out_date') }}
      </div>
    </div>
    <div>
      <label class="required">{{ $t('wholesale.employee') }}</label>
      <a-select
        v-model="model.seller_id"
        :options="employeeList"
        :filterOption="
          (input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
        "
        showSearch
        class="ts-w-full"
      ></a-select>
      <div class="validate" v-if="errors.has('seller_id')">
        {{ errors.first('seller_id') }}
      </div>
    </div>
    <div class="ts-space-y-3">
      <div>
        <label class="required">{{ $t('wholesale.customer') }}</label>
        <div class="ts-flex ts-items-center">
          <a-select
            v-model="model.customer_id"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            showSearch
            :options="customerList"
            @change="onCustomerChange"
            class="ts-w-full"
          ></a-select>
          <a href="#"
            @click.prevent="() => add_new_customer = true"
            v-tooltip="$t('add_new')" 
            class="
              ts-bg-blue-500 ts-h-8 ts-w-8 
            ts-text-white ts-flex ts-items-center 
            ts-rounded-tr ts-rounded-br hover:ts-text-white"
          ><i class="fas fa-plus-square ts-mx-auto"></i></a>
        </div>
        <div class="validate" v-if="errors.has('customer_id')">
          {{ errors.first('customer_id') }}
        </div>
      </div>
      <div class="ts-pl-4">
        <p>
          {{ $t('wholesale.creditAmount') }}:
          <span class="ts-ml-3 ts-text-red-600">{{
            creditAmount ? $currencyFormat(creditAmount) : 0
          }}</span>
        </p>
        <p class="ts-mb-0">
          {{ $t('wholesale.creditDay') }}:
          <input
            v-model.number="model.credit_day"
            @input="creditDayChange"
            type="number"
            class="ts-ml-3 ts-p-1 ts-outline-none"
          />
        </p>
      </div>
    </div>
    <a-drawer
      v-if="add_new_customer"
      :title="$t('wholesale.createNewCustomer')"
      :width="400"
      :zIndex="1020"
      :visible="add_new_customer"
      :body-style="{ paddingBottom: '80px' }"
      :maskClosable="false"
      @close="() => add_new_customer = false"
    >
      <AddNewCustomer  
        @cancel="onCancel"
        @data="setCustomer"
      />
    </a-drawer>

  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'
import AddNewCustomer from './add-new-customer.vue'
export default {
  name: 'customerSaleDate',
  props: ['value', 'validate'],
  components: {
    AddNewCustomer,
  },
  data() {
    return {
      errors: new Errors(),
      add_new_customer: false,
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/operation', ['customers', 'employees']),
    employeeList() {
      return this.employees.map((el) => ({
        value: el.employee_id,
        label: el.employee_name_en,
      }))
    },
    customerList() {
      return this.customers.map((el) => ({
        value: el.customer_id,
        label: el.customer_name,
        credit_amount: el.credit_amount,
        credit_day: el.credit_day,
      }))
    },
    creditAmount() {
      let cus = this.customers.find(
        (c) => c.customer_id == this.model.customer_id
      )
      if (cus) {
        return cus.credit_amount
      }
      return 0
    },
  },
  methods: {
    onCustomerChange(value, opt) {
      this.model.credit_day = opt.data.props.credit_day
			this.creditDayChange()
    },
    creditDayChange() {
      if(this.model.amount_due > 0){
        this.model.next_payment_date = moment().add(this.model.credit_day, 'days').format('DD-MM-YYYY')
      }
    },
    onCancel(){
      this.add_new_customer = false
    },
    setCustomer(data){
      this.$store.commit('wholesale/operation/PUSH_NEW_CUSTOMER', data)
      this.model.customer_id = data.customer_id
      this.creditDayChange()
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>
